import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";

import CustomLoginButton from "UIComponents/CustomLoginButton";
import CustomLoginBoxButton from "UIComponents/CustomLoginBoxButton";

import { Gmail3D, GoogleColored } from "@toddle-edu/ds-icons";
import { isInKioskMode } from "Utils/DeviceDetectHelpers";
import { openSelfLoginWindow } from "Login/modules/LoginModule";

class GoogleLogin extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.customRef) {
      props.customRef(this);
    }
    this.client;
  }

  componentDidMount() {
    const {
      clientId,
      scope,
      loginHint,
      hostedDomain,
      onSuccess,
      onFailure,
      jsLoadedCallBack,
    } = this.props;

    ((d, s, id, cb) => {
      const element = d.getElementsByTagName(s)[0];
      const fjs = element;
      let js = element;
      js = d.createElement(s);
      js.id = id;
      js.src = "//accounts.google.com/gsi/client";
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = cb;
    })(document, "script", "google-login", () => {
      const google = window.google;
      this.client = google?.accounts?.oauth2?.initTokenClient({
        client_id: clientId,
        callback: onSuccess,
        scope,
        hint: loginHint,
        prompt: "select_account",
        hosted_domain: hostedDomain,
        error_callback: onFailure,
      });

      if (jsLoadedCallBack && !_.isEmpty(google?.accounts)) {
        jsLoadedCallBack(true);
      }
    });
  }

  onBtnClick = () => {
    const { onFailure } = this.props;
    if (_.isEmpty(_.get(window, "google.accounts", {}))) {
      onFailure({ error: "google_script_not_loaded" });
      return;
    }

    if (isInKioskMode()) {
      openSelfLoginWindow("GOOGLE");
    } else {
      this.client?.requestAccessToken();
    }
  };

  render() {
    const {
      isBoxButton,
      innerConStyle,
      showLogInButton = true,
      containerStyle,
    } = this.props;

    if (!showLogInButton) {
      return null;
    }

    if (isBoxButton) {
      return (
        <CustomLoginBoxButton
          data-test-id={"button-login-google"}
          icon={<Gmail3D height={88} width={88} />}
          buttonText={"Google"}
          onClick={this.onBtnClick}
        />
      );
    }
    return (
      <CustomLoginButton
        data-test-id={"button-login-google"}
        icon={<GoogleColored size="x-small" />}
        buttonText={"Google"}
        onClick={this.onBtnClick}
        innerConStyle={innerConStyle}
        containerStyle={containerStyle}
      />
    );
  }
}

GoogleLogin.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  offline: PropTypes.bool,
  scope: PropTypes.string,
  className: PropTypes.string,
  redirectUri: PropTypes.string,
  cookiePolicy: PropTypes.string,
  loginHint: PropTypes.string,
  hostedDomain: PropTypes.string,
  isBoxButton: PropTypes.bool,
  children: PropTypes.node,
};

GoogleLogin.defaultProps = {
  buttonText: "Login with Google",
  scope: "profile email",
  redirectUri: "postmessage",
  isBoxButton: false,
  cookiePolicy: "single_host_origin",
};

export default GoogleLogin;
